'use client';

import Image from 'next/image';
import Link from 'next/link';
import notFoundImage from '@/assets/img/dobrozem-not-found.svg';
import { Button } from '@/components/Button';
import { Container } from '@/components/Container';
import { Text } from '@/components/Text';
import styles from './NotFound.module.scss';
type Props = {
  className?: string;
};
export const NotFound = ({}: Props) => {
  return <main className={styles.wrapper} data-sentry-component="NotFound" data-sentry-source-file="NotFound.tsx">
      <Container className={styles.container} data-sentry-element="Container" data-sentry-source-file="NotFound.tsx">
        <Image alt='not found' className={styles.img} src={notFoundImage} data-sentry-element="Image" data-sentry-source-file="NotFound.tsx" />
        <Text color='black' tag='h1' type='h2' data-sentry-element="Text" data-sentry-source-file="NotFound.tsx">Сторінку не знайдено</Text>
        <div className={styles.btnsContainer}>
          <Link href={'/offer/search'} data-sentry-element="Link" data-sentry-source-file="NotFound.tsx">
            <Button asDiv fullWIdth data-sentry-element="Button" data-sentry-source-file="NotFound.tsx">Перейти до оголошень</Button>
          </Link>
          <Link href={'/'} data-sentry-element="Link" data-sentry-source-file="NotFound.tsx">
            <Button asDiv bordered fullWIdth data-sentry-element="Button" data-sentry-source-file="NotFound.tsx">До головної сторінки</Button>
          </Link>
        </div>
      </Container>
    </main>;
};